import { render, staticRenderFns } from "./AyudasFinanciacion.vue?vue&type=template&id=0a47571f&scoped=true&"
var script = {}
import style0 from "./AyudasFinanciacion.vue?vue&type=style&index=0&id=0a47571f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a47571f",
  null
  
)

export default component.exports